import React from 'react';
import BreadcrumbBanner from './BreadcrumbBanner';
import CTASection from './CTASection';
function About() {
  return (
    <div>
      
      <BreadcrumbBanner title="About Us" />

     
      <section className="py-5" style={{ backgroundColor: "#ffffff" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img src="/images/about-us.jpg" alt="About Us" className="img-fluid rounded shadow-lg " />
            </div>
            <div className="col-md-6">
              <h2 className="mb-4 text-primary fw-bold text-center">About Us</h2>
              <p className="lead text-muted mb-4">
                Satish Office Chair Repair & Service is a trusted name for professional office chair repair and maintenance services. We specialize in repairing all types of office chairs, including executive chairs, revolving chairs, mesh chairs, ergonomic chairs, visitor chairs, gaming chairs, and workstation chairs. With years of hands-on experience, we provide affordable, reliable, and same-day repair solutions for homes, offices, corporate companies, schools, hospitals, and commercial spaces. Our skilled technicians use high-quality spare parts to ensure your chair is restored to excellent working condition. Whether it's a broken hydraulic, damaged wheel, loose armrest, or torn seat, we offer quick doorstep service at competitive prices.


              </p>
              
              <div className="row">
                {[
                  { icon: "fa-gem", title: "Quality Products" },
                  { icon: "fa-user-tie", title: "Expertise & Experience" },
                  { icon: "fa-heart", title: "Customer-Centric Approach" },
                  { icon: "fa-layer-group", title: "Comprehensive Services" },
                  { icon: "fa-shield-alt", title: "Reliability" }
                ].map((item, index) => (
                  <div className="col-sm-6 mb-3" key={index}>
                    <div className="d-flex align-items-center">
                      <i className={`fas ${item.icon} text-primary me-3 fa-lg`}></i>
                      <span className="fw-semibold">{item.title}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
        <CTASection />
    </div>
  );
}

export default About;